import { render, staticRenderFns } from "./DeTreeSelect.vue?vue&type=template&id=5a315433&scoped=true&"
import script from "./DeTreeSelect.vue?vue&type=script&lang=js&"
export * from "./DeTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a315433",
  null
  
)

export default component.exports